// api/userApi.ts
import client from './client';
import type { User } from '~/types/types';

function buildUrl(base: string, params: Record<string, string | undefined>): string {
    const queryString = Object.keys(params)
        .filter(key => params[key] !== undefined && params[key] !== '')
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key] as string)}`)
        .join('&');

    return `${base}?${queryString}`;
}

// Fetch users with dynamic query params
export const fetchUsers = async (query: Record<string, any> = {}): Promise<User[]> => {
    try {
        const url = buildUrl('/users', query); // Build URL with query parameters
        const response = await client.get<User[]>(url); // Send GET request with query
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};


// Fetch users with dynamic query params
export const fetchUsersAdmin = async (query: Record<string, any> = {}): Promise<User[]> => {
    try {
        const url = buildUrl('/users/admin', query); // Build URL with query parameters
        const response = await client.get<User[]>(url); // Send GET request with query
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};


export const fetchUsersCategory = async (role?: string, category?: string, status?: string): Promise<User[]> => {
    try {
        const url = buildUrl('/users', { selectedCategory: category, role, status});
        const response = await client.get<User[]>(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchUsersCategoryAdmin = async (role?: string, category?: string, status?: string): Promise<User[]> => {
    try {
        const url = buildUrl('/users/admin', { selectedCategory: category, role, status});
        const response = await client.get<User[]>(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchSearchUsers = async (search?: string): Promise<User[]> => {
    try {
        const url = buildUrl('/users', { search, status: 'online' });
        const response = await client.get<User[]>(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchAdmins = async (): Promise<User[]> => {
    try {
        const response = await client.get<User[]>('/users/admin?admin=1');
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchMe = async (token: string): Promise<User> => {
    try {
        const response = await client.get<User>('/auth/me', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchUserToken = async (token: string, id:string): Promise<any> => {
    try {
        const response = await client.get<any>(`/users/token/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const fetchUserData = async ( id: string): Promise<User> => {
    try {
        const response = await client.get<User>(`/users/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};
export const fetchMeAddress = async (token: string): Promise<User> => {
    try {
        const response = await client.get<User>('/auth/me/addresses', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};
export const fetchUserAddress = async (token: string, id: string): Promise<User> => {
    try {
        const response = await client.get<User>(`/auth/${id}/addresses`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const patchMe = async (id: string, payload: any, token: string): Promise<User> => {
    try {
        const response = await client.patch<User>(`/users/${id}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};


export const updateUserOrders = async (payload: any, token: string): Promise<any> => {
    try {
        const response = await client.patch<any>('/users/order/change', payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting tag:', error);
        throw error;
    }
};
export const patchUser = async (id: string, payload: any, token: string): Promise<User> => {
    try {
        const response = await client.patch<User>(`/users/${id}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};
export const deleteUser = async (id: string, token: string): Promise<User> => {
    try {
        const response = await client.delete<User>(`/users/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const createTalent = async (payload: any, token: string): Promise<User> => {
    try {
        const response = await client.post<User>(`/users`, payload, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const login = async (email: string, password: string): Promise<any> => {
    try {
        const response = await client.post('/auth/login', { email, password });
        console.log('resp', response);
        return response.data;
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};
export const forgotPassword = async (email: string): Promise<any> => {
    try {
        const response = await client.post('/auth/recover', { email });
        console.log('resp', response);
        return response.data;
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};
export const resetPassword = async (token: string, data: any): Promise<any> => {

    try {
        const response = await client.post(`/auth/reset/${token}`, data);
        console.log('reset password', response);
        return response.data;
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};
export const resetEmail = async (data: any, token: string): Promise<any> => {

    try {
        const response = await client.post(`/auth/change-email`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log('reset password', response);
        return response.data;
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};
export const changePassword = async (data: any, token: string): Promise<any> => {

    try {
        const response = await client.post(`/auth/change-password`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log('reset password', response);
        return response.data;
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};
export const checkPassToken = async (token: string): Promise<any> => {
    try {
        const response = await client.get(`/auth/reset/${token}`);
        console.log('reset password', response);
        return response.data;
    } catch (error) {
        console.error('Error logging in:', error);
        throw error;
    }
};